"use client";

import { useEffect, useState } from "react";
import IMobileBigBannerAd from "~/src/components/feature/ad/IMobileBigBannerAd";
import IMobileSpBigBannerAd from "./IMobileSpBigBannerAd";

type IMobileResponsiveBigBannerAdProps = {
  pcAdElementId: string;
  pcAsid: number;
  spAdElementId: string;
  spAsid: number;
};

/**
 * i-mobileレスポンシブビッグバナー広告コンポーネント
 * ブラウザ幅に応じてPC用（728x90）とスマホ用（320x50）の広告を切り替える
 * ブレークポイント: 768px（md）
 */
export default function IMobileResponsiveBigBannerAd({
  pcAdElementId,
  pcAsid,
  spAdElementId,
  spAsid,
}: IMobileResponsiveBigBannerAdProps) {
  //----------
  // ブラウザ幅に応じた表示切り替え
  // SSR時はnullとし、クライアント側で確定後にレンダリング
  //----------
  const [isDesktop, setIsDesktop] = useState<boolean | null>(null);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(min-width: 768px)");

    // 初期値を設定
    setIsDesktop(mediaQuery.matches);

    // リサイズ時に切り替え
    const handleChange = (e: MediaQueryListEvent) => {
      setIsDesktop(e.matches);
    };

    mediaQuery.addEventListener("change", handleChange);
    return () => mediaQuery.removeEventListener("change", handleChange);
  }, []);

  // SSR時・ハイドレーション前は何も表示しない
  if (isDesktop === null) return null;

  if (isDesktop) {
    return (
      <IMobileBigBannerAd
        adElementId={pcAdElementId}
        asid={pcAsid}
      />
    );
  }

  return (
    <IMobileSpBigBannerAd
      adElementId={spAdElementId}
      asid={spAsid}
    />
  );
}
